export function renderTerminalTicker(): string {
    return `
      <section class="terminal-ticker" aria-label="Live market ticker">
        <div class="terminal-ticker__track" id="terminal-ticker-track">Loading live ticker...</div>
      </section>
    `;
}
